// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Apps: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 34" enableBackground="new 0 0 34 34" xmlSpace="preserve" fill="currentColor">
<g>
	<rect x="12.83" y="25.33" width="8.33" height="8.33"/>
	<rect x="0.33" y="0.33" width="8.33" height="8.33"/>
	<rect x="0.33" y="25.33" width="8.33" height="8.33"/>
	<rect x="0.33" y="12.83" width="8.33" height="8.33"/>
	<rect x="12.83" y="12.83" width="8.33" height="8.33"/>
	<rect x="25.33" y="12.83" width="8.33" height="8.33"/>
	<rect x="25.33" y="0.33" width="8.33" height="8.33"/>
	<rect x="25.33" y="25.33" width="8.33" height="8.33"/>
	<rect x="12.83" y="0.33" width="8.33" height="8.33"/>
</g>
</svg>;
};

export default React.memo(Apps);
